// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadingSpinnerFullPage_container__1I1LE","spinner":"LoadingSpinnerFullPage_spinner__2U1RO"};